import {useEffect, useRef} from 'react';
import {isSessionDebugMode} from '@/services/SessionManager';

const IDLE_RESET_MS = 3000;
const WARN_RENDER_COUNTS = [50, 100];
const WARN_DUPLICATE_RENDER_COUNT = 40;

export function useRenderDiagnostics(
    componentName: string,
    snapshot: Record<string, unknown>,
): void {
    const renderCountRef = useRef(0);
    const windowStartRef = useRef(0);
    const lastSnapshotRef = useRef('');

    useEffect(() => {
        if (!isSessionDebugMode()) {
            return;
        }

        const now = Date.now();
        if (!windowStartRef.current || now - windowStartRef.current > IDLE_RESET_MS) {
            renderCountRef.current = 0;
            windowStartRef.current = now;
            lastSnapshotRef.current = '';
        }

        renderCountRef.current += 1;
        const snapshotKey = JSON.stringify(snapshot);
        const unchanged = snapshotKey === lastSnapshotRef.current;
        lastSnapshotRef.current = snapshotKey;

        const elapsed = now - windowStartRef.current;
        const count = renderCountRef.current;

        if (WARN_RENDER_COUNTS.includes(count)) {
            console.warn(`[${componentName}] ${count} renders in ${elapsed}ms`, snapshot);
        }

        if (unchanged && count === WARN_DUPLICATE_RENDER_COUNT) {
            console.warn(
                `[${componentName}] ${count} renders without snapshot change in ${elapsed}ms`,
                snapshot,
            );
        }
    });
}
